import React, { useEffect, useState } from "react";
import { Center, Text, Box } from "@chakra-ui/react";
import { useLocation } from "react-router-dom";
import {
  ProSidebar,
  Menu,
  MenuItem,
  SidebarHeader,
  SidebarContent,
  SubMenu,
} from "react-pro-sidebar";
import { Link } from "react-router-dom";
import logo from "../../../Assets/logo.png";
import logo1 from "../../../Assets/logo1.png";
import { COLORS } from "../../../Helper/Colors";
import "react-pro-sidebar/dist/css/styles.css";
import { useSelector } from "react-redux";
import { USER_ROLE_TYPE } from "../../../Helper/Constants";
import mainLogo from "../../../Assets/Logo.svg";

const Sidebar = ({ navRoutes }) => {
  const { selectedRole } = useSelector((state) => state.loginData);
  const location = useLocation();
  const [activeItem, setActiveItem] = useState(null);

  useEffect(() => {
    setActiveItem(
      location.pathname.split("_")[0] === "/" ? "/dashboard" : location.pathname
    );
  }, [location.pathname, selectedRole?.permissions]);

  return (
    <ProSidebar style={{ background: COLORS.brandDark }}>
      <SidebarHeader style={{ background: COLORS.brandDark, border: "none" }}>
        <Center margin={"10px 0 0 0"}>
          <Box
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            padding={2}
          >
            <Box>
              <img src={mainLogo} alt="logo" width="230" />
            </Box>
            {/* <Box marginLeft={"8px"}>
              <img src={logo} alt="logo" width="200" />
            </Box> */}
          </Box>
        </Center>
      </SidebarHeader>
      <SidebarContent style={{ background: COLORS.brandDark }}>
        {navRoutes.map((item, index) => (
          <Menu key={index}>
            {(selectedRole?.roleType === USER_ROLE_TYPE.ADMIN ||
              selectedRole?.roleType === USER_ROLE_TYPE.SUB_ADMIN) &&
            item.name.toLowerCase() === "back" ? (
              <MenuItem active={false} icon={item.icon}>
                <Link to={item.url} />
                <Text whiteSpace={"pre-wrap"}>{item.name}</Text>
              </MenuItem>
            ) : item.subMenu && item.subMenu.length ? (
              <SubMenu
                title={item.name}
                icon={item.icon}
                defaultOpen={location.state?.openFor === item.url || false}
              >
                {item.subMenu.map((subMenuName, subIndex) => (
                  <MenuItem
                    key={subIndex}
                    active={item.url + subMenuName.url === activeItem}
                  >
                    <Link
                      to={item.url + subMenuName.url}
                      state={{ openFor: item.url }}
                    />
                    <Text whiteSpace={"pre-wrap"} textTransform={"capitalize"}>
                      {subMenuName.name}
                    </Text>
                  </MenuItem>
                ))}
              </SubMenu>
            ) : (
              item.name.toLowerCase() !== "back" && (
                <MenuItem
                  active={
                    item.url === activeItem || activeItem?.startsWith(item.url)
                  }
                  icon={item.icon}
                >
                  <Link to={item.url} />
                  <Text
                    whiteSpace={"pre-wrap"}
                    width={"100%"}
                    textTransform={"capitalize"}
                  >
                    {item.name}
                  </Text>
                </MenuItem>
              )
            )}
          </Menu>
        ))}
      </SidebarContent>
    </ProSidebar>
  );
};

export default Sidebar;
